<template>

    <otif-modal ref="confirm-delete-user" title="Delete User" :value="value" @input="$emit('input', $event)" v-if="user">
        <p>Are you sure you want to delete user <strong>{{ user.get('user_name') }}</strong>?</p>
        <template slot="footer">
            <otif-button className="primary" @click.native="no">No</otif-button>
            <otif-button className="secondary" @click.native="yes">Yes</otif-button>
        </template>
    </otif-modal>
</template>

<script>

export default {
    data() {
        return {
            user: null
            }
    },
    props: ['value'],
    methods: {
        no() {
            this.$emit('input', false);
        },

        yes() {
            this.$snotify.info('Deleting User', {
                timeout: 0
            });

            this.user.delete()
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('User Deleted');

                this.$emit('deleted');
                this.$emit('input', false);
            })
            .catch(() => {
                this.$snotify.clear();
                this.$snotify.error('There was an error deleting the user.');
                this.$emit('input', false);
            });
        }
    }
}
</script>
